export const BackendStatus = {
    'Available': 'AVAILABLE',
    'Unavailable': 'UNAVAILABLE',
    'UnderMaintenance': 'UNDER_MAINTENANCE',
    'SoonUnderMaintenance': 'SOON_UNDER_MAINTENANCE'
};
